export function isNonEmpty(value: unknown) {
  if (Array.isArray(value)) return value.length > 0
  if (value instanceof Date) return !isNaN(value.getTime?.() ?? NaN)
  if (typeof value === 'string') return value.trim().length > 0
  return value !== null && value !== undefined && value !== ''
}
